export default __webpack_public_path__ + "static/media/symbol04.8e1f0f65.svg";